// Port of api/fuel/app/classes/filter/package/games/game/package/versions.php
export default {
	run: function(pkg, local, global) {
		pkg.versions = (global.versions && global.versions[local.game_id]) ? global.versions[local.game_id] : []
		return pkg
	}
}
